import { Cancel } from "@mui/icons-material";
import {
  Button as MuiButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography
} from "@mui/material";

function DialogErroCustomerPassportPhysical({ open, error, onClose })
{
  if (!open)
    return null;

  const customerName = error?.customer_name || "não identificado";
  const dateWithdrawal = error?.date_withdrawal_format || "não informada";
  const collectionPoint = error?.collection_point_passport_name || "não informado";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth>
      <DialogTitle sx={{ background: "#D32F2F" }}>
        <Typography variant="h5" component="div" color="white">
            Erro ao Registrar Retirada de Passaporte Físico
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ paddingTop: 2 }}>
          <Typography variant="h6" component="div">
            O usuário <strong>{customerName}</strong> já retirou o Passaporte Físico.
          </Typography>
        </Box>
        <Box sx={{ paddingTop: 1.5 }}>
          <Typography>
            <strong>Data de Retirada:</strong> {dateWithdrawal}
          </Typography>
        </Box>
        <Box sx={{ paddingTop: 1.5 }}>
          <Typography>
            <strong>Local de Retirada:</strong> {collectionPoint}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <MuiButton startIcon={<Cancel />} color="error" onClick={onClose}>
          Fechar
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
}

export default DialogErroCustomerPassportPhysical;
